const initialState = () => {
  return {
    metadata: null,
    supervisor: null,
    reader: null
  };
};

const reportModule = {
  state: initialState(),

  mutations: {
    saveReport: (state, payload) => {
      state[payload.author] = payload.report;
      state.metadata = payload.metadata;
    }
  },

  getters: {
    report: state => {
      return author => state[author];
    },

    metadata: state => state.metadata
  }
};

export default reportModule;
